import type { RiskFlowAlert } from "./riskflow-feed";

const CACHE_VERSION = "v1";
const MAX_CACHED_ALERTS = 100;

export function readRiskFlowAlertCache(instrument: string): RiskFlowAlert[] {
  try {
    const raw = localStorage.getItem(cacheKey(instrument));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as { alerts?: RiskFlowAlert[] };
    return Array.isArray(parsed.alerts) ? parsed.alerts : [];
  } catch {
    return [];
  }
}

export function writeRiskFlowAlertCache(
  instrument: string,
  alerts: RiskFlowAlert[],
) {
  try {
    localStorage.setItem(
      cacheKey(instrument),
      JSON.stringify({
        cachedAt: new Date().toISOString(),
        alerts: alerts.slice(0, MAX_CACHED_ALERTS),
      }),
    );
  } catch {
    // Storage is best-effort; the live feed remains authoritative.
  }
}

function cacheKey(instrument: string) {
  const normalized = instrument.replace(/[^a-z0-9_-]+/gi, "_").toLowerCase();
  return `fintheon:riskflow-alerts:${CACHE_VERSION}:${normalized || "default"}`;
}
